import { useTranslation } from 'react-i18next';
import { Panel, PanelSection } from '@/shared/ui';
import { SegmentedField } from '@/shared/forms';
import { PlaceholderCostType } from '@/api/generated/schemas';
import {
  costTypeHint,
  placeholderCostTypeOptions,
  placeholderTypeOptions,
} from '../../internal/placeholderEnums';
import { FORM_LABEL_WIDTH } from '../../internal/formLayout';
import type { PlaceholderFormApi } from '../usePlaceholderForm';

/** Panel (1): typ placeholderu + typ nákladu s vysvětlující nápovědou. */
export function PlaceholderTypePanel({ form }: { form: PlaceholderFormApi }) {
  const { t } = useTranslation('venua-planner');

  return (
    <Panel variant="filled" title={t('schemes.placeholderForm.sections.type')}>
      <PanelSection>
        <form.Field
          name="type"
          listeners={{
            // Subkategorie je vázaná na typ — po změně typu ji vyčistíme, aby nezůstala nekonzistentní
            // (uživatel vybere subkategorii nového typu; povinnost hlídá schéma).
            onChange: () => form.setFieldValue('subcategory', null),
          }}
        >
          {(field) => (
            <SegmentedField
              field={field}
              label={t('schemes.placeholderForm.type')}
              labelWidth={FORM_LABEL_WIDTH}
              options={placeholderTypeOptions(t)}
              testId="placeholder-type"
            />
          )}
        </form.Field>

        <form.Field name="costType">
          {(field) => (
            <SegmentedField
              field={field}
              label={t('schemes.placeholderForm.costType')}
              labelWidth={FORM_LABEL_WIDTH}
              options={placeholderCostTypeOptions(t)}
              helperText={costTypeHint(t, field.state.value as PlaceholderCostType)}
              testId="placeholder-cost-type"
            />
          )}
        </form.Field>
      </PanelSection>
    </Panel>
  );
}
